import { Host, h } from "@stencil/core";
const EXPANDABLE = "expandable";
/**
 * @part accordion__expandable - The container of the accordion content
 *
 * @slot header - The component to be displayed in the header of the control
 * @slot content - The component to be displayed as the content of the accordion (below the header)
 */
export class Accordion {
    constructor() {
        this.accessibleDescription = "";
        this.accessibleName = "";
        this.expanded = false;
    }
    /**
     * Fired when the content is expanded or collapsed
     */
    expandedChange;
    toggleExpanded = () => {
        const newExpandedValue = !this.expanded;
        this.expanded = newExpandedValue;
        this.expandedChange.emit(newExpandedValue);
    };
    render() {
        return (h(Host, null, h("button", { "aria-controls": EXPANDABLE, "aria-expanded": this.expanded.toString(), "aria-label": this.accessibleName, "aria-description": this.accessibleDescription || undefined, class: "header", part: "accordion__header", type: "button", onClick: this.toggleExpanded }, h("slot", { name: "header" }), h("div", { "aria-hidden": "true", class: { chevron: true, "chevron--expanded": this.expanded }, part: "accordion__chevron" })), h("div", { id: EXPANDABLE, class: { expandable: true, expanded: this.expanded }, part: "accordion__expandable" }, h("slot", { name: "content" }))));
    }
    static get is() { return "ch-accordion"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["accordion.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["accordion.css"]
        };
    }
    static get properties() {
        return {
            "accessibleDescription": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The description of the entity."
                },
                "attribute": "accessible-description",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "accessibleName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The name of the entity."
                },
                "attribute": "accessible-name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "expanded": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "`true` if the accordion is expanded."
                },
                "attribute": "expanded",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "expandedChange",
                "name": "expandedChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fired when the content is expanded or collapsed"
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=accordion.js.map
